import styled, { keyframes } from 'styled-components';

/*
  This file wasn't provided in full — only its exports were inferred from
  usage inside Processing.jsx / Extraction.jsx / Analysis.jsx. Rebuilt here
  using the same theme.landing.* / landingSpacing / landingBorderRadius /
  landingBreakpoints tokens as UploadDocuments.styles.js so light/dark mode
  keeps working the same way. If you already have a real processing.styles.js,
  merge the new exports at the bottom (ExtractionTabsWrapper, Analysis*,
  ContinueButton) into it instead of replacing the file wholesale.
*/

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

export const ProcessingWrapper = styled.div`
  width: 100%;
  min-height: calc(100vh - 64px);
  background: ${({ theme }) => theme.landing.background};
  transition: background 0.3s ease;
`;

export const ProcessingContainer = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  margin-top: 64px;
  padding: ${({ theme }) => theme.landingSpacing.xl};

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.lg}) {
    padding: ${({ theme }) => theme.landingSpacing.lg};
  }
  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    padding: ${({ theme }) => theme.landingSpacing.md};
  }
`;

export const HeaderSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${({ theme }) => theme.landingSpacing.xl};
  gap: ${({ theme }) => theme.landingSpacing.md};
  flex-wrap: wrap;

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.md}) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const SectionTitle = styled.h1`
  font-weight: 500;
  font-size: 1.75rem;
  margin: 0;
  color: ${({ theme }) => theme.landing.text};
  letter-spacing: -0.025em;
`;

export const SectionDescription = styled.p`
  font-size: 1rem;
  color: ${({ theme }) => theme.landing.textSecondary};
  margin: 4px 0 0 0;
`;

export const ActionButtons = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.landingSpacing.sm};

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    width: 100%;
    flex-direction: column;
  }
`;

export const DashboardButton = styled.button`
  background: transparent;
  color: ${({ theme }) => theme.landing.text};
  border: 1px solid ${({ theme }) => theme.landing.cardBorder};
  border-radius: ${({ theme }) => theme.landingBorderRadius.md};
  padding: ${({ theme }) => theme.landingSpacing.sm} ${({ theme }) => theme.landingSpacing.md};
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.landing.iconBg};
  }
  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    width: 100%;
  }
`;

export const ContinueButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background: ${({ theme }) => theme.landing.buttonBg};
  color: #fff;
  border: 1px solid ${({ theme }) => theme.landing.buttonBg};
  border-radius: ${({ theme }) => theme.landingBorderRadius.md};
  padding: ${({ theme }) => theme.landingSpacing.sm} ${({ theme }) => theme.landingSpacing.md};

  cursor: pointer;

  &:hover:not(:disabled) {
    background: ${({ theme }) => theme.landing.buttonHover};
    box-shadow: 0px 8px 16px rgba(37, 99, 235, 0.2);
  }
  &:disabled {
    background: ${({ theme }) => theme.landing.iconBg};
    color: ${({ theme }) => theme.landing.textSecondary};
    border-color: ${({ theme }) => theme.landing.cardBorder};
    cursor: not-allowed;
  }
  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    width: 100%;
    justify-content: center;
  }
`;

export const ContentLayout = styled.div`
  display: grid;
  grid-template-columns: 300px 1fr;
  gap: ${({ theme }) => theme.landingSpacing.lg};
  align-items: start;

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.md}) {
    grid-template-columns: 1fr;
  }
`;

export const DocumentsPanel = styled.div`
  background: ${({ theme }) => theme.landing.cardBg};
  border: 1px solid ${({ theme }) => theme.landing.cardBorder};
  border-radius: ${({ theme }) => theme.landingBorderRadius.lg};
  padding: ${({ theme }) => theme.landingSpacing.md};
`;

export const PanelTitle = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: ${({ theme }) => theme.landing.text};
  padding: 6px 10px 14px;
`;

export const DocumentsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 480px;
  overflow-y: auto;
`;

export const DocumentItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 10px;
  border-radius: ${({ theme }) => theme.landingBorderRadius.md};
  border: 1px solid transparent;

  &:hover {
    background: ${({ theme }) => theme.landing.background};
    border-color: ${({ theme }) => theme.landing.cardBorder};
  }
`;

export const DocIconWrapper = styled.div`
  width: 32px;
  height: 32px;
  border-radius: ${({ theme }) => theme.landingBorderRadius.md};
  background: ${({ theme }) => theme.landing.iconBg};
  color: ${({ theme }) => theme.landing.buttonBg};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const DocInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const DocName = styled.div`
  font-size: 13.5px;
  font-weight: 600;
  color: ${({ theme }) => theme.landing.text};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ResultsPanel = styled.div``;

export const TabsBar = styled.div`
  display: flex;
  gap: 4px;
  padding: 12px 12px 0;
  background: ${({ theme }) => theme.landing.iconBg};
  border: 1px solid ${({ theme }) => theme.landing.cardBorder};
  border-bottom: none;
  border-radius: ${({ theme }) => theme.landingBorderRadius.lg}
    ${({ theme }) => theme.landingBorderRadius.lg} 0 0;
`;

export const Tab = styled.button`
  font-size: 13px;
  font-weight: 600;
  padding: 10px 18px 12px;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  color: ${({ theme }) => theme.landing.textSecondary};

  ${({ $active, theme }) =>
    $active &&
    `
      color: ${theme.landing.text};
      border-color: ${theme.landing.buttonBg};
    `}
`;

export const TabContent = styled.div`
  background: ${({ theme }) => theme.landing.cardBg};
  border: 1px solid ${({ theme }) => theme.landing.cardBorder};
  border-top: none;
  border-radius: 0 0 ${({ theme }) => theme.landingBorderRadius.lg}
    ${({ theme }) => theme.landingBorderRadius.lg};
`;

export const TabContentWrapper = styled.div`
  padding: 22px 26px 26px;
`;

export const ExtractionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 16px;
`;

export const ExtractionTitle = styled.h3`
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: ${({ theme }) => theme.landing.text};
`;

export const ExtractedBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12.5px;
  font-weight: 700;
  background: ${({ theme }) => theme.landing.iconBg};
  border: 1px solid ${({ theme }) => theme.landing.cardBorder};
  padding: 6px 12px;
  border-radius: 99px;
  color: ${({ theme }) => theme.landing.textSecondary};
`;

export const ExtractionTabsWrapper = styled.div`
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  margin-bottom: 14px;
`;

export const ExtractionTabItem = styled.button`
  font-size: 12.5px;
  font-weight: 600;
  padding: 7px 14px;
  border-radius: 99px;
  border: 1px solid ${({ theme }) => theme.landing.cardBorder};
  background: transparent;
  color: ${({ theme }) => theme.landing.textSecondary};
  cursor: pointer;

  ${({ $active, theme }) =>
    $active &&
    `
      background: ${theme.landing.buttonBg};
      border-color: ${theme.landing.buttonBg};
      color: #fff;
    `}
`;

export const ExtractionList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export const ExtractionItem = styled.div`
  border: 1px solid ${({ theme }) => theme.landing.cardBorder};
  border-radius: ${({ theme }) => theme.landingBorderRadius.lg};
  padding: 18px 20px;
  scroll-margin-top: 90px;
`;

export const ItemSource = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: ${({ theme }) => theme.landing.textSecondary};
  margin-bottom: 6px;
`;

export const ItemSourceDoc = styled.span`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const ItemSourceDot = styled.span``;

export const ItemSourcePage = styled.span``;

export const ItemTitle = styled.div`
  font-size: 15px;
  font-weight: 700;
  color: ${({ theme }) => theme.landing.text};
  margin-bottom: 12px;
`;

export const ExtractionFieldGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 18px 24px;

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.md}) {
    grid-template-columns: 1fr 1fr;
  }
  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    grid-template-columns: 1fr;
  }
`;

export const ExtractionField = styled.div``;

export const FieldLabel = styled.div`
  font-size: 11px;
  font-weight: 700;
  color: ${({ theme }) => theme.landing.textSecondary};
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 6px;
`;

export const FieldValue = styled.div`
  font-size: 13.5px;
  color: ${({ theme }) => theme.landing.text};
  line-height: 1.55;
  white-space: pre-line;
`;

export const StatusMessage = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  margin-top: 10px;
  color: ${({ $type, theme }) =>
    $type === 'error' ? 'var(--color-text-danger)' : theme.landing.textSecondary};
`;

export const ExtractButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background: ${({ theme }) => theme.landing.buttonBg};
  color: #fff;
  border: none;
  border-radius: ${({ theme }) => theme.landingBorderRadius.md};
  padding: 10px 18px;
  /* font-weight: 600; */
  cursor: pointer;

  &:hover:not(:disabled) {
    background: ${({ theme }) => theme.landing.buttonHover};
  }
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .spin {
    animation: ${spin} 1s linear infinite;
  }
`;

export const LoadingState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 4rem 1rem;
  color: ${({ theme }) => theme.landing.textSecondary};
  font-size: 14px;

  .spin {
    animation: ${spin} 1s linear infinite;
  }
`;

export const EmptyExtractionState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 3rem 1rem;
  text-align: center;
  color: ${({ theme }) => theme.landing.textSecondary};

  .spin {
    animation: ${spin} 1s linear infinite;
  }
`;

export const GlobalError = styled.div`
  background: var(--color-background-danger);
  border: 0.5px solid var(--color-border-danger);
  border-radius: var(--border-radius-md);
  padding: 10px 14px;
  font-size: 13px;
  color: var(--color-text-danger);
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: ${({ theme }) => theme.landingSpacing.lg};
`;

/* ---- Analysis ---- */

export const AnalysisItemGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 14px;
`;

export const AnalysisItemCard = styled.div`
  border: 1px solid ${({ theme }) => theme.landing.cardBorder};
  border-radius: ${({ theme }) => theme.landingBorderRadius.lg};
  padding: 18px 20px;
  background: ${({ theme }) => theme.landing.background};
`;

export const AnalysisItemHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  gap: 10px;
`;

export const AnalysisItemTitle = styled.div`
  font-size: 14.5px;
  font-weight: 700;
  color: ${({ theme }) => theme.landing.text};
`;

export const AnalysisScoreBadge = styled.div`
  font-size: 12px;
  font-weight: 700;
  padding: 4px 10px;
  border-radius: 99px;
  flex-shrink: 0;

  ${({ $score }) => {
    if ($score >= 80)
      return `background: var(--color-background-success, rgba(34,197,94,0.12)); color: var(--color-text-success, #22c55e);`;
    if ($score >= 40)
      return `background: var(--color-background-warning, rgba(245,158,11,0.12)); color: var(--color-text-warning, #f59e0b);`;
    return `background: var(--color-background-danger, rgba(239,68,68,0.12)); color: var(--color-text-danger, #ef4444);`;
  }}
`;

export const AnalysisProgressTrack = styled.div`
  height: 6px;
  border-radius: 99px;
  background: ${({ theme }) => theme.landing.iconBg};
  overflow: hidden;
  margin-bottom: 10px;
`;

export const AnalysisProgressBar = styled.div`
  height: 100%;
  width: ${({ $score }) => Math.max(0, Math.min(100, $score))}%;
  border-radius: 99px;

  ${({ $score }) => {
    if ($score >= 80) return `background: var(--color-text-success, #22c55e);`;
    if ($score >= 40) return `background: var(--color-text-warning, #f59e0b);`;
    return `background: var(--color-text-danger, #ef4444);`;
  }}
`;

export const AnalysisItemResponse = styled.div`
  font-size: 13.5px;
  color: ${({ theme }) => theme.landing.textSecondary};
  line-height: 1.6;
`;
